import {inject, ref} from "vue";

export function useTicketOutlets() {
    const api = inject('api');
    const outlets = ref([]);
    const isLoadingOutlets = ref(false);

    async function loadOutlets({searchTerm = null, lat = null, lng = null} = {}) {
        if(isLoadingOutlets.value) {
            return;
        }

        isLoadingOutlets.value = true;

        try {
            const results = await api.getTicketOutlets({searchTerm, lat, lng})
            outlets.value = results.data.data;
        } catch (e) {}

        isLoadingOutlets.value = false;
    }

    return {
        outlets,
        isLoadingOutlets,

        // methods
        loadOutlets,
    }
}
